/** Brand + neutral color tokens shared across light and dark themes. */
export const brand = {
  primary: '#2563eb',
  primaryDark: '#1d4ed8',
  secondary: '#7c3aed',
  success: '#16a34a',
  warning: '#d97706',
  error: '#dc2626',
  info: '#0891b2',
};

export const lightPalette = {
  background: '#f6f8fb',
  paper: '#ffffff',
  textPrimary: '#111827',
  textSecondary: '#5b6472',
  divider: '#e5e7eb',
};

export const darkPalette = {
  background: '#0b1020',
  paper: '#131a2b',
  textPrimary: '#e6eaf2',
  textSecondary: '#9aa4b6',
  divider: '#26304a',
};

export type ThemeMode = 'light' | 'dark';
export type Density = 'comfortable' | 'compact';
